import { createUpserter } from '@/app/shared/utils'
import { AddSectionDurationCommand, UpdateSectionStateCommand } from '../api'
import { SectionState, defaultSectionState } from './section-state'

export type SectionStates = SectionState[];
export type SectionCommand = UpdateSectionStateCommand | AddSectionDurationCommand;

const upsert = createUpserter<SectionState>((id) => defaultSectionState(id));

export function sectionStateReducer(state: SectionStates, command: SectionCommand) {
  switch (command.name) {
    case 'add-section-duration':

      return upsert(state, command.payload.sectionId, (section) => {
        const status: SectionState = {
          ...section,
          details: {
            ...section.details,
            durationSeconds: section.details.durationSeconds + command.payload.durationSeconds
          }

        };
        return status;
      });

    case 'update-section-state':
      const payload = command.payload;
      return upsert(state, command.payload.sectionId, (section) => {
        const status: SectionState = {
          ...section,
          details: {
            ...section.details,
            progress: payload.progress,
            status: payload.status
          }
        };

        return status;
      });
  }
}
